<template>
  <div class="app">
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-row>
        <v-col v-for="item in 2" :key="item" cols="2">
          <v-skeleton-loader class="mx-auto" type="button" />
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="item in 3" :key="item">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="item in 3" :key="item">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form ref="form" v-show="!showSkeleton">
      <v-row dense>
        <v-col cols="3">
          <v-text-field
            dense
            v-model="form.acao.description"
            :counter="35"
            label="Descrição"
            :error-messages="descriptionErrors"
            @input="$v.form.acao.description.$touch()"
            @blur="$v.form.acao.description.$touch()"
          />
        </v-col>
        <v-col class="ml-14" cols="2">
          <v-switch dense v-model="form.active" label="Ativo" />
        </v-col>
        <v-col cols="3">
          <v-switch dense v-model="form.acao.continuar" label="Executar Próxima Ação Válida" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            dense
            v-model="form.regexVisualOrigem"
            :counter="20"
            label="Expressão de Origem"
            :error-messages="regexVisualOrigemErrors"
            @input="
              $v.form.regexVisualOrigem.$touch()
              form.regexVisualOrigem = $event.trim()
            "
            @blur="$v.form.regexVisualOrigem.$touch()"
          />
        </v-col>
        <v-col>
          <v-text-field
            dense
            v-model="form.regexVisualDestino"
            :error-messages="regexVisualDestinoErrors"
            :counter="20"
            label="Expressão de Destino"
            @input="
              $v.form.regexVisualDestino.$touch()
              form.regexVisualDestino = $event.trim()
            "
            @blur="$v.form.regexVisualDestino.$touch()"
          />
        </v-col>
        <v-col>
          <v-select
            dense
            v-model="form.acao.centroDeCusto"
            :error-messages="centroDeCustoErrors"
            :items="centroDeCusto"
            label="Centro de Custo"
            @input="$v.form.acao.centroDeCusto.$touch()"
            @blur="$v.form.acao.centroDeCusto.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-select
            dense
            v-model="form.alliasRegexOrigem"
            label="Grupos de Expressões Origem"
            :items="alliasRegexOrigem"
          />
        </v-col>
        <v-col cols="4">
          <v-select
            dense
            v-model="form.alliasRegexDestino"
            label="Grupos de Expressões Destino"
            :items="alliasRegexDestino"
          />
        </v-col>
      </v-row>

      <DraggAndDropAvaliacaoAtendimento
        dragname="Avaliações"
        :arrayPesquisa="avaliacoesAtendimento"
        @dragUpdate="updateAcoes($event)"
        :opcoesSelecionadas="avaliacoesSelecionadas"
      />
    </v-form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'

import { rotasMixin } from '../_mixins/rotasMixins'
import { pesquisaSatisfacaoMixins } from '../_mixins/pesquisaSatisfacaoMixins'

export default {
  name: 'AtivarRegex',

  mixins: [validationMixin, rotasMixin, pesquisaSatisfacaoMixins],
  data: () => ({
    form: {
      description: 'SETAR PESQUISA',
      regexVisualOrigem: '',
      regexVisualDestino: '',
      alliasRegexOrigem: '',
      alliasRegexDestino: '',
      active: true,
      acao: {
        description: 'SETAR PESQUISA',
        class: 'Modules\\Agi\\Entities\\acoes\\SetarPesquisa',
        centroDeCusto: '',
        record: true,
        continuar: true,
        pesquisas: [],
      },
    },
  }),

  async created() {
    await Promise.all([this.listarAvaliacoesAtendimento(), this.listarCentroDeCustos(), this.listarRegex()])

    this.getItemsSelectAvaliacoesAtendimento()
    this.getItemsSelectCentroDeCusto()
    this.getItemsSelectRegexOrigemEDestino()

    this.makeFormulario()

    this.avaliacoesSelecionadas = [...this.form.acao.pesquisas]
    this.showSkeleton = false
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
